module.exports = __webpack_public_path__ + "static/media/video_call.8739ebda.svg";